import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Typography,
  TextField,
  DialogActions,
  Button,
  IconButton,
  Box,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/CloseRounded";
import PropTypes from "prop-types";
import { Formik } from "formik";
import * as Yup from "yup";

const CompanySalesEmailDialogComponent = ({
  selectedCompany,
  onCompanySalesEmailDialogSubmitClick,
  onCompanySalesEmailDialogCloseClick,
  viewOnly = false,
  isSubmitting = false,
}) => {
  if (!selectedCompany) {
    return null;
  }
  return (
    <Dialog
      open={!!selectedCompany}
      onClose={onCompanySalesEmailDialogCloseClick}
      scroll="paper"
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      fullWidth
    >
      <Formik
        initialValues={{
          salesEmail:
            selectedCompany.company?.sales_email ||
            selectedCompany.sales_email ||
            "",
        }}
        validationSchema={Yup.object().shape({
          salesEmail: Yup.string()
            .email("Invalid sales email")
            .required("Sales Email is required"),
        })}
        onSubmit={onCompanySalesEmailDialogSubmitClick}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <form onSubmit={handleSubmit}>
            <DialogTitle id="scroll-dialog-title">
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography variant="body2">
                  <b>
                    {selectedCompany.company?.name ||
                      selectedCompany.name ||
                      ""}
                    &nbsp;-&nbsp;
                    {viewOnly ? "View Sales Email" : "Update Sales Email"}
                  </b>
                </Typography>
                <IconButton
                  size="small"
                  color="inherit"
                  onClick={onCompanySalesEmailDialogCloseClick}
                  style={{ padding: 0 }}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
            </DialogTitle>
            <DialogContent dividers style={{ backgroundColor: "#f3f3f3" }}>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  label="Sales Email"
                  name="salesEmail"
                  fullWidth
                  value={values.salesEmail}
                  required
                  onChange={handleChange}
                  onBlur={handleBlur}
                  disabled={isSubmitting}
                  error={touched.salesEmail && errors.salesEmail}
                  helperText={touched.salesEmail && errors.salesEmail}
                  inputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />
              </Grid>
            </DialogContent>
            {!viewOnly && (
              <DialogActions>
                <Button
                  variant="contained"
                  type="submit"
                  disabled={isSubmitting}
                >
                  Save
                </Button>
              </DialogActions>
            )}
          </form>
        )}
      </Formik>
    </Dialog>
  );
};

CompanySalesEmailDialogComponent.propTypes = {
  selectedCompany: PropTypes.object,
  onCompanySalesEmailDialogCloseClick: PropTypes.func.isRequired,
};

export default CompanySalesEmailDialogComponent;
